(() => {
  if (!window.WJInitCardQuickAddForms) {
    window.WJInitCardQuickAddForms = (root = document) => {
      const formatMoney = (cents) => {
        const normalized = typeof cents === 'string' ? Number(cents.replace('.', '')) : Number(cents || 0);
        if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(normalized);

        const amount = normalized / 100;
        const locale = document.documentElement.lang || 'en-US';
        const currency = window.Shopify?.currency?.active || 'USD';
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
          }).format(amount);
        } catch (error) {
          return amount.toFixed(2);
        }
      };

      const getVariants = (form) => {
        const element = form.querySelector('.ProductVariantsJSON');
        if (!element) return [];
        try {
          return JSON.parse(element.textContent);
        } catch (error) {
          return [];
        }
      };

      const getVariantMediaMap = (form) => {
        const element = form.querySelector('.VariantMediaJSON');
        if (!element) return {};
        try {
          const data = JSON.parse(element.textContent);
          return data.reduce((map, item) => {
            map[item.id] = item;
            return map;
          }, {});
        } catch (error) {
          return {};
        }
      };

      const updateCardMedia = (form, variant) => {
        if (!variant) return;
        const mediaMap = getVariantMediaMap(form);
        const media = mediaMap[variant.id];
        if (!media || !media.has_media) return;

        const card = form.closest('.card-wrapper');
        if (!card) return;
        const primaryImg = card.querySelector('img[data-card-primary-image]');
        if (!primaryImg) return;

        if (media.srcset) {
          primaryImg.setAttribute('srcset', media.srcset);
        } else {
          const parts = [];
          if (media.src_165) parts.push(`${media.src_165} 165w`);
          if (media.src_360) parts.push(`${media.src_360} 360w`);
          if (media.src_533) parts.push(`${media.src_533} 533w`);
          if (media.src_720) parts.push(`${media.src_720} 720w`);
          if (media.src_940) parts.push(`${media.src_940} 940w`);
          if (media.src_1200) parts.push(`${media.src_1200} 1200w`);
          if (media.src_1500) parts.push(`${media.src_1500} 1500w`);
          if (media.src_1066) parts.push(`${media.src_1066} 1066w`);
          primaryImg.setAttribute('srcset', parts.join(', '));
        }

        primaryImg.setAttribute('src', media.src || media.src_720 || media.src_533 || media.src_360 || media.src_165);
        if (media.alt) primaryImg.setAttribute('alt', media.alt);
        if (media.width) primaryImg.setAttribute('width', media.width);
        if (media.height) primaryImg.setAttribute('height', media.height);
      };

      const updateCardPrice = (form, variant) => {
        if (!variant) return;
        const card = form.closest('.product-card-wrapper');
        if (!card) return;

        const current = card.querySelector('[data-card-price-current]');
        const compare = card.querySelector('[data-card-price-compare]');
        const price = card.querySelector('[data-card-price]');
        if (!current || !compare || !price) return;

        current.textContent = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.hidden = false;
          compare.textContent = formatMoney(variant.compare_at_price);
          price.classList.add('product-card-price--sale');
        } else {
          compare.hidden = true;
          compare.textContent = '';
          price.classList.remove('product-card-price--sale');
        }
      };

      const setState = (form, variant) => {
        if (!variant) return;

        const idInput = form.querySelector('.product-variant-id');
        const button = form.querySelector('.quick-add__submit');
        const label = form.querySelector('[data-card-submit-label]');

        if (idInput) idInput.value = variant.id;
        if (button) {
          button.toggleAttribute('disabled', !variant.available);
          button.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
        }
        if (label) {
          label.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }

        updateCardPrice(form, variant);
        updateCardMedia(form, variant);
      };

      const syncQuickAddQuantity = (form) => {
        const quantityInput = form.querySelector('[name="quantity"]');
        const quantityDisplay = form.querySelector('[data-quantity-display]');
        const rawQuantity = quantityDisplay?.textContent?.trim() || quantityInput?.value || '1';
        const quantity = Number.parseInt(rawQuantity, 10);

        if (!Number.isFinite(quantity) || quantity < 1) return null;

        const normalizedQuantity = String(quantity);

        if (quantityInput) {
          quantityInput.value = normalizedQuantity;
          quantityInput.setAttribute('value', normalizedQuantity);
          return normalizedQuantity;
        }

        const fallbackInput = document.createElement('input');
        fallbackInput.type = 'hidden';
        fallbackInput.name = 'quantity';
        fallbackInput.value = normalizedQuantity;
        form.append(fallbackInput);
        return normalizedQuantity;
      };

      root.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
        if (form.dataset.qaFormInit === 'true') return;
        form.dataset.qaFormInit = 'true';

        form.addEventListener('submit', () => syncQuickAddQuantity(form), true);
        form.addEventListener('formdata', (event) => {
          const quantity = syncQuickAddQuantity(form);
          if (quantity) event.formData.set('quantity', quantity);
        });

        ['click', 'mousedown', 'pointerdown', 'touchstart'].forEach((eventName) => {
          form.addEventListener(
            eventName,
            (event) => {
              event.stopPropagation();
            },
            false
          );
        });

        const variants = getVariants(form);
        if (!variants.length) return;

        const idInput = form.querySelector('.product-variant-id');
        const select = form.querySelector('[data-card-variant-select]');

        const resolveVariant = () => {
          const selectedId = Number(select?.value || idInput?.value || 0);
          return (
            variants.find((variant) => variant.id === selectedId) ||
            variants.find((variant) => variant.available) ||
            variants[0]
          );
        };

        const sync = () => {
          const variant = resolveVariant();
          if (!variant) return;
          if (select && String(select.value) !== String(variant.id)) {
            select.value = String(variant.id);
          }
          setState(form, variant);
        };

        if (select) {
          select.addEventListener('change', sync);
        }

        sync();
      });
    };
  }

  const run = () => window.WJInitCardQuickAddForms(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
